import axios, { AxiosError, AxiosRequestConfig, HttpStatusCode } from "axios";
import { notificarErroNaRequisicao } from "../Utils/Notificacoes";

export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    skipUnauthorizedLogout?: boolean;
    doNotNotify?: boolean | ((err: AxiosError) => boolean);
}
// 'https://quiron.azurewebsites.net/api/api'
export let Axios = axios.create({
    baseURL: process.env.NODE_ENV === "development" ? 'https://localhost:7123/api' : `${window.location.origin}/api/api`,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'Access-Control-Allow-Origin': '*'
    }
})

export const configurarSessaoDoAxios = (token: string, logout: Function) => {
    
    Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    Axios.interceptors.response.use(response => {
        return response;
    }, async (error: AxiosError) => {
        console.log("interceptors: ", error);
        const errorConfig = error.config as CustomAxiosRequestConfig;
        const status = error.response?.status;

        if (errorConfig.responseType === "blob" && error.response?.data instanceof Blob && error.response?.data.type) {
            const text = await error.response.data.text();

            const data = error.response.data.type.toLowerCase().includes('json') ? JSON.parse(text) : text;
            error.response.data = data as any;
        }        

        if(errorConfig?.skipUnauthorizedLogout === true && status === HttpStatusCode.Unauthorized){
            throw error;
        }

        if (status === HttpStatusCode.Unauthorized) {
            Axios.interceptors.response.clear();
            logout();
        }

        else if ( typeof(errorConfig.doNotNotify) === "function"? errorConfig.doNotNotify?.(error) !== true : errorConfig.doNotNotify !== true) {
            console.log("Erro Requisição");
            notificarErroNaRequisicao(error);
        }

        throw error;
    });
}
